// AUTO-GENERATED — DO NOT EDIT
//     run `just codegen-experiment-function … --frontend-client --target-app ask` to regenerate.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
// Note: The following attributes are automatically provided by the experiment provider
// and do not need to be passed as parameters: userEmail
export const useMaybeStudentDomainsRegexVariation = makeBooleanFlagValueHook('maybe-student-domains-regex');
//# sourceMappingURL=useMaybeStudentDomainsRegexVariation.js.map